import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { SelectResourceAndPeriod } from './SelectResourceAndPeriod';
import { MakeReservation } from './MakeReservation';
import './Forms.css';
import './Booking.css';

export class Booking extends Component {
  displayName = Booking.name

  constructor(props) {
    super(props);

    this.state = {
      localizations: [],
      loadingLocalizations: true,
      resource: undefined,
      resourceGroup: undefined,
      period: { valid: false, description: '' },
      currentStep: 0,
      queryParam: require('query-string').parse(props.location.search),
      formComplete: false,
      singleResource: false,
    };

    fetch('api/Localizations/' + this.state.queryParam.lang)
      .then(response => response.json())
      .then(data => {
        this.setState({
          // eslint-disable-next-line
          localizations: data.reduce((map, obj) => (map[obj.rowKey] = obj.value, map), {}), loadingLocalizations: false
        });
      });
  }

  goToStep(step) {
    if (step === 2) {
      this.postReservation()
        .then(response => {
          this.setState({ currentStep: step, submitted: (response.ok) });
        });
    }
    else {
      this.setState({ currentStep: step });
    }
  }

  postReservation() {
    let reservation = {
      firstName: this.state.contact.firstName,
      lastName: this.state.contact.lastName,
      addressLine1: this.state.contact.addressLine1,
      addressLine2: this.state.contact.addressLine2,
      postalCode: this.state.contact.postalCode,
      city: this.state.contact.city,
      country: this.state.contact.country,
      phone: this.state.contact.phone,
      email: this.state.contact.email,
      remarks: this.state.contact.remarks,
      startDate: this.state.period.start,
      endDate: this.state.period.end,
      userLanguage: this.state.queryParam.lang,
      resourceId: this.state.resource.rowKey,
      resourceGroupId: this.state.resource.resourceGroupId
    };

    return fetch(`api/Reservations/${this.state.queryParam.tenant}`, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(reservation)
    });
  }


  onPeriodChange(period) {
    period.description = this.buildPeriodText(period);
    this.setState({ period: period });
  }

  clearPeriod() {
    const newPeriod = { start: undefined, end: undefined, valid: false };
    this.setState({ period: newPeriod });
  }

  onResourceChange(resource, resourceGroup, singleResource) {
    this.setState({ resource: resource, resourceGroup: resourceGroup, singleResource: singleResource });
  }

  buildPeriodText(period) {
    if (period.start === undefined || period.end === undefined) {
      return this.state.localizations.NoDateSelected;
    } else {
      if (period.valid) {
        let dateFormatter = new Intl.DateTimeFormat(this.state.localizations.Culture, {
          year: 'numeric',
          month: 'long',
          day: '2-digit'
        });

        const nights = Math.round((period.end - period.start) / (1000 * 60 * 60 * 24));
        const nightsText = nights === 1 ? this.state.localizations.Night : this.state.localizations.Nights;

        return `${this.state.localizations.SelectedPeriod}: ${dateFormatter.format(period.start)} ${this.state.localizations.Till} ${dateFormatter.format(period.end)} (${nights} ${nightsText})`;
      } else {
        return this.state.localizations.SelectedPeriodNotAvailable;
      }
    }
  }

  formComplete(contact) {
    this.setState({ formComplete: true, contact: contact });
  }

  formIncomplete() {
    this.setState({ formComplete: false });
  }

  render() {

    if (!this.state.loadingLocalizations) {
      return (
        <div>
          <div className={this.state.currentStep === 0 ? "" : "hidden"}>
            <SelectResourceAndPeriod
              localizations={this.state.localizations}
              tenant={this.state.queryParam.tenant}
              lang={this.state.queryParam.lang}
              resId={this.state.queryParam.resId}
              period={this.state.period}
              onResourceChange={(resource, resourceGroup, singleResource) => this.onResourceChange(resource, resourceGroup, singleResource)}
              onPeriodChange={period => this.onPeriodChange(period)}
              selectedResource={this.state.resource}
            />
            <div>{this.state.period.description}
              { this.state.period.start &&
                <Button className="clear-button" onClick={() => this.clearPeriod()}>{this.state.localizations.Clear}</Button>
              }
            </div>
            <Button bsStyle="primary" className="pull-right" disabled={!this.state.period.valid || this.state.period.start === undefined || this.state.period.end === undefined} onClick={() => this.goToStep(1)}>{this.state.localizations.RequestReservation}</Button>
          </div>
          <div className={this.state.currentStep === 1 ? "" : "hidden"}>
            <div>
              <div className="panel panel-default">
                <div className="panel-body">
                  <h3>{this.state.localizations.YourStay}</h3>
                  <p>{this.state.localizations.Where}: {this.state.resourceGroup && this.state.resourceGroup.description} {this.state.resource && (this.state.singleResource == false) ? ` - ${this.state.resource.description}` : ""}</p>
                  <p>{this.state.period !== null ? this.state.period.description : ""}</p>
                </div>
              </div>
              <p>{this.state.localizations.FillOutForm}</p>
              <MakeReservation
                localizations={this.state.localizations}
                tenant={this.state.queryParam.tenant}
                lang={this.state.queryParam.lang}
                period={this.state.period}
                resource={this.state.resource}
                onFormComplete={(contact) => this.formComplete(contact)}
                onFormIncomplete={() => this.formIncomplete()}
              />
            </div>
            <div className="d-flex justify-content w-100">
              <div className="justify-content-start">
                <Button onClick={() => this.goToStep(0)}>{this.state.localizations.Back}</Button>
              </div>
              <div className="justify-content-end">
                <Button bsStyle="primary" disabled={!this.state.formComplete} onClick={() => this.goToStep(2)}>{this.state.localizations.RequestReservation}</Button>
              </div>
            </div>
          </div>
          <div className={this.state.currentStep === 2 ? "" : "hidden"}>
            {this.state.submitted ?
              <p>{this.state.localizations.ThankYou}</p> :
              <div className="error-panel">
                <img src="window.jpg" alt="error" align="right" className="error-image" />
                <h1>Oh dear...</h1>
                <h3>You weren't supposed to see this.</h3>
                <p>If you got here, that means something has gone wrong on our server. We are really, really sorry. You can try submitting your request again. It that doesn't work,
                              please try getting in touch with us via phone or email.</p>
                <Button onClick={() => this.goToStep(0)}>{this.state.localizations.Back}</Button>
              </div>
            }
          </div>
        </div>
      );
    }
    else {
      return <div>One moment please...</div>;
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/Booking.js